import CfpSelect from './CfpSelect'

interface TaQuestionPickerProps {
  questions: any[]
  currentIndex: number
  onChange: (index: number) => void
  title?: string
}

export default function TaQuestionPicker({ questions, currentIndex, onChange, title }: TaQuestionPickerProps) {
  // Map question rows into CfpSelect options. Labels can be ReactNodes so we
  // keep the HTML rendering for question text (matches the legacy picker).
  const options = questions.map((q, i) => ({
    value: i,
    label: <span dangerouslySetInnerHTML={{ __html: q.question ?? '' }} />,
  }))

  return (
    <CfpSelect<number>
      label={title}
      placeholder="Select question..."
      clearable
      value={currentIndex >= 0 ? currentIndex : ('' as any)}
      onChange={(v) => onChange(v === ('' as any) ? -1 : Number(v))}
      options={options}
      menuMinWidth={420}
      triggerMaxWidth={420}
      fullWidth
    />
  )
}
